module.exports = __webpack_public_path__ + "img/optimized-career@2x.9c7df7f2.png";